module.exports = __webpack_public_path__ + "static/media/guide_2_3.99d7c029.png";